import React from "react";
import { createRoot } from "react-dom/client";
import MyApp from "./App";
import "../shared/styles/tailwind.css";
import "../shared/styles/index.css";
import "../shared/styles/ui.css";
import "../shared/styles/tokens.css";
import "../shared/styles/effects.css";
import "../shared/styles/paramcategory.css";
import {setAuthTokenProvider} from "../shared/api/contentClient";
import { getAccessToken } from "../shared/api/authClient";
import {initTheme} from "../shared/theme/applyTheme";


// Content API reads Bearer token from the same source as authClient (memory-first).
setAuthTokenProvider(() => getAccessToken() ?? localStorage.getItem("access_token"));

initTheme();
const container = document.getElementById("root");
const root = createRoot(container);

root.render(<MyApp />);
